module.exports = __webpack_public_path__ + "static/media/scRNA.453970cf.png";